export default __webpack_public_path__ + "static/media/Carbon.705009d0.png";